import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SonntagButton } from '../SonntagButtonV2/SonntagButton.js';

const CtaButton = ({ className , size , fullWidth , iconPath , iconSvgCode , children , disabled , ...props })=>{
    const theme = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(SonntagButton, {
        className: className,
        iconPath: iconPath,
        iconSvgCode: iconSvgCode,
        disabled: disabled,
        fullWidth: fullWidth,
        size: size,
        solid: true,
        accentColor: theme.colors.Color1,
        ...props
    }, children);
};

export { CtaButton };
